export const VERSION = '1.0.0'
export const FILES = 'files'
export const contract = {
    qq_chanel: 'https://pd.qq.com/s/2vtw8jd09',
    wx_gzh: 'https://www.zhanshi123.me/wp-content/uploads/2025/09/campus_gzh.jpg',
    bilibili_er: 'https://www.bilibili.com/video/BV1kFq1YcELP',
    help_er: 'https://help.anqstar.com/blog/2024/2024%E5%B9%B412%E6%9C%8823%E6%97%A5',
    no_cont: 'https://help.anqstar.com/docs/question/ER%E5%9B%BE%E6%B2%A1%E6%9C%89%E8%81%94%E7%B3%BB',
}
